module.exports = __webpack_public_path__ + "static/media/ramazan-desktop-banner-2026.f77aea04.jpg";